import { useCallback } from "react";

import { useFeatureFlag } from "@/domain/_shared/feature-flag/hooks/api/use-feature-flag";
import { overlayInventorySectorList } from "@/domain/inventory/lib/overlay-inventory-sector-list";
import { GHG_ADMINISTRATION_METHODOLOGY_ID, GPC_METHODOLOGY_ID } from "@ark/shared";

export interface FilterableInventory {
  id: string;
  methodologyId?: string | null;
  methodology?: object | null;
  sectorList?: { inventoryId?: string | null }[] | null;
}

export const useInventoryListFeatureFilter = (workspaceId: string) => {
  const { isEnabled: isGpcEnabled } = useFeatureFlag({ workspaceId, id: "enable-gpc-inventories" });
  const { isEnabled: isGhgAdministrationEnabled } = useFeatureFlag({
    workspaceId,
    id: "enable-ghg-for-administrations-inventory",
  });

  return useCallback(
    <T extends FilterableInventory>(inventoryList: readonly (T | null)[]): T[] => {
      const visibleList = inventoryList.filter((inventory): inventory is T => {
        if (!inventory) {
          return false;
        }
        if (!isGpcEnabled && inventory.methodologyId === GPC_METHODOLOGY_ID) {
          return false;
        }
        if (!isGhgAdministrationEnabled && inventory.methodologyId === GHG_ADMINISTRATION_METHODOLOGY_ID) {
          return false;
        }
        return true;
      });
      return visibleList.map(overlayInventorySectorList);
    },
    [isGpcEnabled, isGhgAdministrationEnabled],
  );
};
